import * as React from "react"
import i18n from 'i18n'

import RadioMultiButton from "./RadioButton"
import { useCommonFilters } from '../../hooks'


export default function RadioAlert({ ...props }) {

    const { alerts, setAlerts, setAlertType } = useCommonFilters()

    const configRadio = {
        value: alerts, onChange: setAlerts, changeAlertType: setAlertType,
        items: [
            { label: i18n.t('common:filters.alertCompetition'), value: 'competition' },
            { label: i18n.t('common:filters.alertParity'), value: 'parity', disabled: true },
            { label: i18n.t('common:filters.alertPackages'), value: 'packages', disabled: true }
        ],
        ...props
    }

    return <RadioMultiButton {...configRadio} />
}